module.exports = __webpack_public_path__ + "static/media/silkycloud-pink-2.5fefa18e.png";